import { OverviewDetailsFilterModel } from "./OverviewDetailsFilterModel";

export const OVERVIEW_FILTER_KEY = "monitorDashboard.overviewFilter";

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export function getTodayStr(): string {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return yyyy + "-" + mm + "-" + dd;
}

export function loadOverviewFilterFromStorage(target: OverviewDetailsFilterModel): void {
    try {
        const raw = sessionStorage.getItem(OVERVIEW_FILTER_KEY);
        if (!raw) {
            return;
        }
        const parsed = JSON.parse(raw);
        if (parsed && parsed.dateFrom) {
            target.dateFrom = parsed.dateFrom;
        }
        if (parsed && parsed.dateTo) {
            target.dateTo = parsed.dateTo;
        }
        if (parsed && parsed.tenantId) {
            target.tenantId = parsed.tenantId;
        } else if (parsed && parsed.tenant) {
            target.tenantId = parsed.tenant;
        }
        if (parsed && parsed.providerId) {
            target.providerId = parsed.providerId;
        }
        if (parsed && parsed.customerType != null) {
            target.customerType = Number(parsed.customerType);
        }
        if (parsed && parsed.requestType != null) {
            target.requestType = Number(parsed.requestType);
        }
    } catch (e) {
    }
}

export function buildOverviewScopePayload(filter: OverviewDetailsFilterModel): any {
    return {
        dateFrom: filter.dateFrom,
        dateTo: filter.dateTo || getTodayStr(),
        tenantId: filter.tenantId,
        providerId: filter.providerId,
        customerType: filter.customerType || null,
        requestType: filter.requestType || 0,
    };
}

export function formatCreatedDate(value: string): string {
    if (!value) {
        return "";
    }
    const s = String(value);
    if (s.length >= 10) {
        return s.substring(0, 10);
    }
    return s;
}

export function assignRowKeys(rows: any[]): any[] {
    const result: any[] = [];
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        row.rowKey =
            String(row.createdDate) +
            "-" +
            String(row.senderName) +
            "-" +
            String(i);
        result.push(row);
    }
    return result;
}

export function downloadExcelFromBase64(base64: string, fileName: string): void {
    try {
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        const blob = new Blob([bytes], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    } catch (e) {
    }
}
